import React from 'react';
import { Content } from './shared';

const BcbsTxFluShot = () => (
  <Content>
    The following pharmacies and clinics offer free flu shots:
    <ul>
      <li>CVS</li>

      <li>Osco Drug</li>

      <li>Target</li>

      <li>Walgreens</li>

      <li>Walmart</li>
    </ul>
    Note: Be sure to confirm with the provider that they accept your medical plan before receiving
    services.
  </Content>
);

export default BcbsTxFluShot;
